// English translations (default, bundled with main)
export default {
  translation: {
    auth: {
      welcomeBack: 'Welcome Back',
      createAccount: 'Create Account',
      signInToContinue: 'Sign in to continue finding love',
      joinAndStart: 'Join and start meeting people',
      name: 'Name',
      yourName: 'Your name',
      email: 'Email',
      password: 'Password',
      forgotPassword: 'Forgot password?',
      rememberMe: 'Remember me',
      signIn: 'Sign In',
      signUp: 'Create Account',
      orContinueWith: 'Or continue with',
      continueWithGoogle: 'Continue with Google',
      continueWithApple: 'Continue with Apple',
      noAccount: "Don't have an account? Sign up",
      hasAccount: 'Already have an account? Sign in',
      needVerification: 'Need a new verification email?',
      safetyTips: 'Safety Tips for Online Dating',
      ageConfirmTitle: 'I confirm that I am 18 years of age or older',
      ageConfirmDesc: 'By checking this box, you verify that you meet the minimum age requirement to use this service.',
      termsTitle: 'I agree to the',
      termsOf: 'Terms of Service',
      and: 'and',
      privacyPolicy: 'Privacy Policy',
      termsDesc: 'You must accept to create an account.',
      checkEmail: 'Check Your Email',
      verificationSent: "We've sent a verification link to",
      clickLink: 'Click the link in the email to verify your account and start finding your match!',
      resendEmail: 'Resend Email',
      backToSignIn: 'Back to Sign In',
      didntReceive: "Didn't receive the email? Check your spam folder or try resending.",
      resetPassword: 'Reset Password',
      enterEmailReset: "Enter your email and we'll send you a reset link",
      sendResetLink: 'Send Reset Link',
      passwordResetSent: "We've sent a password reset link to",
      resetLinkExpire: 'Click the link in the email to reset your password. The link will expire in 24 hours.',
      resendVerification: 'Resend Verification Email',
      enterEmailVerify: "Enter your email and we'll send you a new verification link",
      resendVerificationBtn: 'Resend Verification Email',
      checkSpam: "Make sure to check your spam folder if you don't see the email.",
      passwordRequirements: 'Password requirements:',
      atLeast8Chars: 'At least 8 characters',
      containsNumber: 'Contains a number',
      containsUppercase: 'Contains uppercase letter',
      containsSpecial: 'Contains special character (!@#$...)',
    },
    nav: {
      discover: 'Discover',
      premium: 'Premium',
      smashes: 'Smashes',
      messages: 'Messages',
      profile: 'Profile',
    },
    profile: {
      title: 'Profile',
      editProfile: 'Edit Profile',
      settings: 'Settings',
      language: 'Language',
      selectLanguage: 'Select your preferred language',
      notifications: 'Notifications',
      notificationDesc: 'Get notified when you match with someone or receive a new message.',
      pushNotifications: 'Push Notifications',
      notificationsEnabled: 'Notifications enabled',
      notificationsDisabled: 'Notifications disabled',
      youllReceive: "You'll receive alerts based on your preferences",
      enableToGet: 'Enable to get notified instantly',
      enable: 'Enable',
      disable: 'Disable',
      notificationsBlocked: 'Notifications Blocked',
      notificationsBlockedDesc: "You've blocked notifications for this site. Please enable them in your browser settings.",
      notificationPreferences: 'Notification Preferences',
      newMatches: 'New Matches',
      newMatchesDesc: 'When you match with someone',
      messagesLabel: 'Messages',
      messagesDesc: 'New messages from your matches',
      likes: 'Likes',
      likesDesc: 'When someone swipes right on you',
      meetTonight: 'Meet Tonight',
      meetTonightDesc: 'New pairings and session updates',
      notSupported: 'Push notifications are not supported on this device/browser. Try using a modern browser like Chrome, Firefox, or Edge.',
      logout: 'Log Out',
      deleteAccount: 'Delete Account',
      dataExport: 'Export My Data',
      changePassword: 'Change Password',
    },
    discover: {
      title: 'Discover',
      noMoreProfiles: 'No more profiles',
      checkBackLater: 'Check back later for new people',
      swipeLeft: 'Swipe left to pass',
      swipeRight: 'Swipe right to like',
      yearsOld: 'years old',
      away: 'away',
    },
    matches: {
      title: 'Your Smashes',
      noMatches: 'No matches yet',
      startSwiping: 'Start swiping to find your match!',
      unmatch: 'Unmatch',
      viewProfile: 'View Profile',
      sendMessage: 'Send Message',
    },
    messages: {
      title: 'Messages',
      noConversations: 'No conversations yet',
      matchToChat: 'Match with someone to start chatting!',
      typeMessage: 'Type a message...',
      send: 'Send',
    },
    common: {
      loading: 'Loading...',
      error: 'Error',
      success: 'Success',
      cancel: 'Cancel',
      save: 'Save',
      delete: 'Delete',
      confirm: 'Confirm',
      back: 'Back',
      next: 'Next',
      done: 'Done',
      close: 'Close',
      search: 'Search',
      filter: 'Filter',
      sort: 'Sort',
      yes: 'Yes',
      no: 'No',
      km: 'km',
      mi: 'mi',
    },
    landing: {
      findYourMatch: 'Find Your Match',
      tagline: 'Swipe, match, and meet amazing people near you',
      getStarted: 'Get Started',
      signIn: 'Sign In',
    },
  },
};
